/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { UploadItem, UploadStatus } from '@gh/core-ui';
import { assign, isNil, isString } from 'lodash';

export type ThumbnailSource = string | UploadItem | { file: string };

enum ThumbnailKind { Placeholder, Url, Blob }

function isUploadItem(data: any): data is UploadItem {
  return !isNil(data['location']);
}

@Component({
  selector: 'gh-thumbnail',
  template: require('./thumbnail.component.html'),
  styles: [require('./thumbnail.component.scss')],
})
export class ThumbnailComponent implements OnDestroy {
  @ViewChild('image', { static: true }) image: ElementRef;

  private _source: ThumbnailSource;
  private kind = ThumbnailKind.Placeholder;
  private url: any;

  @Input()
  set source(source: ThumbnailSource) {
    this._source = source;

    let kind;
    let url;
    if (isNil(source)) {
      kind = ThumbnailKind.Placeholder;
      url = void 0;
    } else if (isString(source)) {
      kind = ThumbnailKind.Url;
      url = source;
    } else if (isUploadItem(source) && source.status === UploadStatus.Completed) {
      kind = ThumbnailKind.Url;
      url = source.location;
    } else if (source['file'] instanceof Blob) {
      kind = ThumbnailKind.Blob;
      url = URL.createObjectURL(source['file']);
    } else {
      kind = ThumbnailKind.Placeholder;
      url = void 0;
    }

    this.cleanUrl();

    assign(this, { kind, url });

    this.image.nativeElement.src = url;
  }

  get displayPlaceholder(): boolean {
    return this.kind === ThumbnailKind.Placeholder;
  }

  ngOnDestroy(): void {
    this.cleanUrl();
  }

  private cleanUrl(): void {
    if (this.kind === ThumbnailKind.Blob) {
      URL.revokeObjectURL(this.url);
    }
  }
}
